// JS Module to handle backend API requests

const API_BASE = '/api';

export async function getBalance(scripthash) {
    const res = await fetch(`${API_BASE}/balance`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ scripthash, network: 'itc' })
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
}

export async function getUtxos(scripthash) {
    const res = await fetch(`${API_BASE}/utxos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ scripthash, network: 'itc' })
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
}

export async function broadcastTx(hex) {
    const res = await fetch(`${API_BASE}/broadcast`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hex, network: 'itc' })
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
}
